export default {
	LOGIN_SSO_ERROR_MESSAGE_LTI: '1',
	LOGIN_SIGNUP_ERROR_MESSAGE_LTI: '2',
}
